import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import {
  ArrowLeft,
  ExternalLink,
  Home,
  Loader2,
  ShieldAlert,
} from "lucide-react";
import { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function InformasiJalur() {
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawUrl = searchParams.get("embedUrl") || "";

  // Daftar link spesifik yang diizinkan (White-list ketat)
  const ALLOWED_LINKS = useMemo(
    () => [
      "https://undiksha.ac.id/pmb/tahun2026/snbp/",
      "https://undiksha.ac.id/pmb/tahun2026/snbt/",
      "https://undiksha.ac.id/pmb/tahun2026/smbjm/",
      "https://undiksha.ac.id/penerimaan-mahasiswa-baru-pascasarjana-tahun-akademik-2026-2027/",
    ],
    [],
  );

  const embedUrl = useMemo(() => {
    if (!rawUrl) return null;

    // Tambahkan protokol jika user hanya mengetik domain (opsional, tapi bagus untuk stabilitas)
    const formattedUrl = rawUrl.startsWith("http")
      ? rawUrl
      : `https://${rawUrl}`;

    // Cek apakah URL yang dimasukkan ada di dalam daftar ALLOWED_LINKS
    const isAllowed = ALLOWED_LINKS.includes(formattedUrl);

    return isAllowed ? formattedUrl : "INVALID";
  }, [rawUrl, ALLOWED_LINKS]);

  return (
    <main className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <Navbar />
      <div className="mt-5 flex flex-col space-y-4 w-full h-[calc(100vh-100px)] max-h-[850px] p-4 max-w-6xl mx-auto">
        {embedUrl && embedUrl !== "INVALID" && (
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <Button
              variant="outline"
              className="w-full sm:w-auto bg-white dark:bg-slate-900"
              onClick={() => navigate("/")}
            >
              <Home className="w-4 h-4 mr-2" />
              Kembali ke Beranda
            </Button>
            <Button
              className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition-all"
              onClick={() => window.open(embedUrl, "_blank")}
            >
              Buka Halaman Asli
              <ExternalLink className="w-4 h-4 ml-2" />
            </Button>
          </div>
        )}

        <div className="relative flex-1 w-full bg-white dark:bg-slate-900 rounded-3xl overflow-hidden border border-slate-200 dark:border-slate-800 shadow-xl">
          {/* CASE 1: LOADING STATE */}
          {isLoading && embedUrl && embedUrl !== "INVALID" && (
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-white dark:bg-slate-900 z-20">
              <Loader2 className="w-10 h-10 text-blue-600 animate-spin mb-4" />
              <p className="text-sm font-medium text-slate-600 dark:text-slate-400 animate-pulse">
                Menyambungkan ke Server Resmi...
              </p>
            </div>
          )}

          {/* CASE 2: LINK TIDAK TERDAFTAR */}
          {!embedUrl || embedUrl === "INVALID" ? (
            <div className="flex flex-col items-center justify-center h-full p-8 text-center">
              <div className="w-20 h-20 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mb-6">
                <ShieldAlert className="w-10 h-10 text-amber-600 dark:text-amber-400" />
              </div>
              <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">
                Halaman Tidak Diizinkan
              </h2>
              <p className="text-slate-500 dark:text-slate-400 max-w-md mb-8">
                Maaf, tautan ini tidak terdaftar dalam basis data informasi
                resmi kami.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button variant="outline" onClick={() => navigate(-1)}>
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Kembali
                </Button>
              </div>
            </div>
          ) : (
            /* CASE 3: IFRAME TAMPIL */
            <iframe
              src={embedUrl}
              className="w-full h-full border-none"
              onLoad={() => setIsLoading(false)}
              title="Informasi Jalur Pendaftaran"
              // Catatan: Jika halaman masih "Refused to Connect", itu adalah kebijakan server Undiksha
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
              loading="lazy"
            />
          )}
        </div>

        <p className="text-[11px] text-center text-slate-400 italic">
          Keamanan: Menampilkan konten terverifikasi dari undiksha.ac.id
        </p>
      </div>
    </main>
  );
}
